import { isLocalhost } from './registerServiceWorker';
import king from './king.png';
import logo from './logo.png';

//name:{king,griffon}
let proyect = 'griffon';
// let proyect = 'king';
let open = false;

let format,lan,logofinal, name, lastname;

if (proyect == "king") {
  format = "AMERICAN";
  lan = "es";
  logofinal = king;
  name = 'KING';
  lastname = 'DEPORTES';

} else if (proyect = "griffon") {
  format = "AMERICAN";
  lan = "es";
  logofinal = logo;
  name = 'GRIFFON.';
  lastname = 'BET';
}


if (isLocalhost) {
  // baseURL = 'http://localhost:8000/';
  
}

export const OPEN = open;
export const FORMAT = format;
export const LAN = lan;
export const LOGO = logofinal;
export const NAME = name;
export const LASTNAME = lastname;



// WEBPACK FOOTER //
// ./src/settings.js